// #region Imports
import { defineComponent } from "vue";
// #endregion
// #region Core
export default defineComponent({
    // #region Class
    name: 'g-account-userpassword_change',
    // #endregion
    // #region Mixins
    mixins: [host.mixins.modal],
    // #endregion
    // #region Properties
    props: {
        accountId: {
            type: String,
            required: true,
            default: ''
        },
        userId: {
            type: String,
            required: true,
            default: ''
        }
    },
    computed: {
        form() {
            return this.$refs?.frmMain?.$form;
        }
    },
    // #endregion
    // #region Data
    data: () => ({
        _password: '',
        _password2: '',
        _errorMessage: '',
        _step: 1,
        _isLoading: false,
    }),
    // #endregion
    // #region Boostrap
    created() {
    },
    // #endregion
    // #region Methods
    methods: {
        async onNext() {
            // #region Set
            this._errorMessage = '';
            this._isLoading = true;
            // #endregion
            // #region Step 1 => 2
            if (!this.form.validate()) {
                this._isLoading = false;
                return;
            }
            try {
                //Run
                await host.api.post('identity/profile/' + this.userId + '/change/password', null, { params: { password: this._password, userID: this.userId, accountId: this.accountId } });
                //Set
                this.$host.login.connect();
                this.currentWindow.close(1);
            }
            catch (e) {
                this._errorMessage = utils.getAxiosErrorMessage(e);
            }
            // #endregion
            // #region Finish
            this._isLoading = false;
            // #endregion
        }
    }
    // #endregion
});
// #endregion
